import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '../classes';

@Pipe({
    name: 'productBarrierType',
    pure: false
})
export class ProductBarrierTypePipe implements PipeTransform {
    transform(type: number): string {
        return Helper.textsHelper().getProductBarrierTypeName(type);
    }
}
